
import { send_bienlai_rq, send_bienlai_rq_multiple } from "../models/request/bien-lai/send_bienlai_rq";
import { apiClient } from "./apiClient";

export const SF_BIENLAI_PRINT = "sf_bienlaithu/print"
export const SF_BIENLAI_SEND = "sf_bienlaithu/send_bienlai"
export const SF_BIENLAI_SEND_MULTIPLE = "sf_bienlaithu/send_bienlai_multiple"
export const SF_BIENLAI_SENDTHUXACNHAN = "sf_bienlaithu/send_thuxacnhan"
export const SF_BIENLAI_UPDATENGAYTHU = "sf_bienlaithu/update-ngaythu"
export const SF_BIENLAI_GETBYCHUNGTU = "sf_bienlaithu/get-by-sochungtu?so_chung_tu="

export const bienLaiThuApi = {
    print: (sf_mucphaithu_id: number) => apiClient.post(`${SF_BIENLAI_PRINT}?sf_mucphaithu_id=${sf_mucphaithu_id}`),
    send_bienlai: (data: send_bienlai_rq) => apiClient.post(`${SF_BIENLAI_SEND}`, data),
    update_ngaythu: (data: any) => apiClient.post(`${SF_BIENLAI_UPDATENGAYTHU}`, data),
    get_by_chungtu: (so_chung_tu: string) => apiClient.get(`${SF_BIENLAI_GETBYCHUNGTU}` + so_chung_tu),
    send_thuxacnhan: (data: send_bienlai_rq) => apiClient.post(`${SF_BIENLAI_SENDTHUXACNHAN}`, data),
    send_bienlai_multiple: (data: send_bienlai_rq_multiple) => apiClient.post(`${SF_BIENLAI_SEND_MULTIPLE}`, data),


}
